<template>
  <iframe
    ref="iframe"
    :src="src"
    width="100%"
    height="100%"
    frameborder="0"
    allowtransparency
  />
</template>

<script>
export default {
  name: 'GameFrame',

  props: {
    projectId: {
      required: true
    },

    domain: {
      required: true
    },

    token: {
      required: true
    }
  },

  data() {
    return {
      src: this.buildSrc()
    }
  },

  methods: {
    buildSrc() {
      return (
        'https://' +
        this.domain +
        '/backstage/campaigns' +
        '?token=' +
        this.token
      )
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-dashboard/GameFrame.vue